export type ErrorDisplay = {
  title: string;
  description?: string;
};

export class AppError extends Error {
  public display: ErrorDisplay;
  public statusCode?: number;

  constructor(display: ErrorDisplay, statusCode?: number) {
    super(display.title);
    this.display = display;
    if (statusCode) {
      this.display.title = display.title + ` (${statusCode})`;
    }
    this.statusCode = statusCode;
  }
}
